import { cn, dynamicStyling } from 'styles';

import { BaseLoaderProps } from './types';

export function SpinnerLoader({ className, size = 18 }: BaseLoaderProps) {
  return (
    <span
      {...dynamicStyling({
        size,

        borderColor: `currentColor transparent transparent transparent`,

        borderWidth: '2px 2px 0 0',

        className: cn('inline-block shrink-0 animate-spin rounded-full', className),
      })}
    />
  );
}
